export class BestHouseNumber{
    items: Array<BestHouseNumberItem>;

    public static mergeJSON(instance: any, data: any): BestHouseNumber{
        if (!data) { return instance; }
        if (data.items != null) {
            instance.items = [];
            ([].concat(data.items)).forEach(occurrence => {
                instance.items.push(new BestHouseNumberItem().fromJSON(occurrence)); // i3
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestHouseNumber.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestHouseNumber) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestHouseNumber.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestHouseNumber): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}

export class BestHouseNumberItem{
    best_id: string;
    housenumber: string;
    boxnumber:string;
    addresses_complete_id: string;

    public static mergeJSON(instance: any, data: any): BestHouseNumberItem {
        if (!data) { return instance; }
        if (data.best_id != null) {instance.best_id = data.best_id }
        if (data.housenumber != null) {instance.housenumber = data.housenumber }
        if (data.boxnumber != null) {instance.boxnumber = data.boxnumber }
        if (data.addresses_complete_id != null) {instance.addresses_complete_id = data.addresses_complete_id }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestHouseNumberItem.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestHouseNumberItem) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestHouseNumberItem.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestHouseNumberItem): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}
